import { Component } from '@angular/core';
import { SessionService } from 'src/app/state';

@Component({
  selector: 'em-admin-button',
  styleUrls: ['./admin-button.component.less'],
  templateUrl: './admin-button.component.html',
  standalone: false,
})
export class AdminButtonComponent {
  public role$ = this.sessionService.role$;

  public constructor(private readonly sessionService: SessionService) {}
}
